/** 
 * Represents the possible statuses for a background operation.
 * Matches Crown.X.Api.LongRunningOperations.Models.BackgroundOperationState enum.
 */
export enum BackgroundOperationState {
	/** 
	 * Request has been sent to the server to start the background operation, but the server has not responded yet.
	 * Currently this is only used by the client when initiating a background operation, and is not a state that is returned from the server.
	 */
	Pending = -1,

	/** Background operation is currently being processed. */
	Processing = 0,

	/** Background operation completed successfully. */
	Success = 1,

	/** Background operation failed with errors. */
	Failed = 2,

	/** Background operation was canceled before completion. */
	Canceled = 3,

	/** Background operation is locked during processing and cannot be canceled. */
	LockedProcessing = 4
}